import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectSkuCategories } from "../../../redux/sku";
import { APP_PATHS } from "../../../constants/paths";
import { SKUS_QUERY_STRING } from "../../../constants/skus";
import classes from "./CategoriesSection.module.css";

const CategoriesSection = () => {
  const categories = useSelector(selectSkuCategories);
  if (categories.length === 0) return null;

  return (
    <section className={classes["categories"]}>
      <h2 className={classes["categories__header"]}>بتدور على إيه ؟</h2>
      <ul className={classes["categories__list"]}>
        {categories.map((category, index) => (
          <li key={index} className={classes["categories__list-item"]}>
            <Link
              to={`${APP_PATHS.SKUS.url}?${SKUS_QUERY_STRING.CATEGORY_NAME}=${category.name}&${SKUS_QUERY_STRING.CATEGORY_ID}=${category.id}`}
              className={classes["categories__link"]}
            >
              <img
                src={category.image}
                alt={category.name}
                className={classes["categories__category-img"]}
              />
            </Link>
            <p className={classes["categories__name"]}>{category.name}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default CategoriesSection;
